enum WindowMode {
  UNKNOWN = 'unknown',
  PWA = 'pwa',
  REACTNATIVE = 'reactnative',
  ELECTRON = 'electron',
}

export default WindowMode;